import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MomentModule } from 'ngx-moment';
import { NgxPrintModule } from 'ngx-print';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { SafePipeModule } from 'safe-pipe';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { MessagesModule } from '../messages/messages.module';
import { MessageDisplayDialogComponent } from './message-display-dialog.component';
import { MessageListComponent } from './message-list.component';
import { SMSMessageComponent } from './sms-message.component';
import { MessageActions } from './state/message.actions';
import { MessageEffects } from './state/message.effects';
import { VoiceMessageComponent } from './voice-message.component';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule.forRoot(),
        DropdownModule,
        TableModule,
        FormsModule,
        MomentModule,
        TranslateModule,
        MultiSelectModule,
        InfiniteScrollModule, // NOTE: This is NOT our custom version
        SafePipeModule,
        NgxPrintModule,
        EffectsModule.forFeature([MessageEffects]),
        MessagesModule
    ],
    declarations: [
        MessageListComponent,
        MessageDisplayDialogComponent,
        SMSMessageComponent,
        VoiceMessageComponent
    ],
    providers: [
        // MessageService,
        AuthenticationSelectors,
        MessageActions
    ],
    exports: [
        MessageListComponent,
        VoiceMessageComponent,
        SMSMessageComponent
    ]
})
export class MessageListModule {
}
